import React, { useEffect, useMemo, useState } from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import TitledSection from '../../../common/TitledSection/TitledSection';
import classes from './scss/myUploadedCV.module.scss';
import api from '../../../../api/apiSettings';
import { CV_FILE_ALLOWED_FORMATS, MAX_CV_FILE_SIZE, validationMessages } from '../../../../utils/constants';
import ValidationErrorLabel from '../../../common/ValidationErrorLabel/ValidationErrorLabel';

function MyUploadedCV(props) {
  const { cvName } = props;

  const [fileName, setFileName] = useState('');
  const [errors, setErrors] = useState([]);
  const { t } = useTranslation();
  const validationMessage = useMemo(() => validationMessages(t), [t]);

  const validateInputFile = (file) => {
    const currentErrors = [];
    if (!CV_FILE_ALLOWED_FORMATS.includes(file.name.split('.').pop()))
      currentErrors.push(validationMessage.CV_ALLOWED_FORMATS);
    if (file.size > MAX_CV_FILE_SIZE) currentErrors.push(validationMessage.CV_ALLOWED_FILE_SIZE);
    return currentErrors;
  };

  const replaceFile = async (event) => {
    setErrors([]);
    const validationErrors = validateInputFile(event.target.files[0]);

    if (validationErrors.length) {
      setErrors(validationErrors);
      return;
    }

    const data = new FormData();
    data.append('cv', event.target.files[0]);

    await api.post('v1/upload-cv', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    setFileName(event.target.files[0].name);
  };

  useEffect(() => {
    if (cvName) setFileName(cvName);
  }, [cvName]);

  return (
    <TitledSection title={t('dashboard.profile.mycv')}>
      <div className={classes.inputContent}>
        <span className={classes.fileName}>{fileName}</span>
        <Button
          variant="outlined"
          color="primary"
          component="label"
          className={classes.uploadButton}
          sx={{
            textTransform: 'none'
          }}
        >
          {t('dashboard.profile.replacefile')}
          <input type="file" accept=".pdf,.docx,.doc" hidden onChange={replaceFile} />
        </Button>
      </div>
      <div className="d-flex flex-column">
        {!!errors.length && errors.map((err) => <ValidationErrorLabel key={err} message={err} />)}
      </div>
    </TitledSection>
  );
}

export default MyUploadedCV;
